import React, { Component } from "react";

import {
  CDataTable,
  CLink,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CSpinner
} from "@coreui/react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import Interface from "../../../Interface";

const appRoot = document.getElementById("root");

class InterfaceModal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        show={this.props.show}
        onClose={this.props.onClose}
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>{this.props.title}</CModalHeader>
        <CModalBody className="p-0">
          <Interface
            show={this.props.show}
            title={this.props.title}
            aula={this.props.aula}
            modal={false}
          />
        </CModalBody>
      </CModal>,
      this.el
    );
  }
}

class ModalContentDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      loading: true,
      iframe: false,
      contentName: "",
      contentId: null
    };
  }

  componentDidMount() {
    axios
      .get(`${URL.api}statistics/contents_details`, {
        params: this.props.filter,
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ data: resp.data.data, loading: false });
      });
  }

  openInterface(e, item) {
    e.preventDefault();

    this.setState({ iframe: true, contentName: item.name, contentId: item.id });
  }

  render() {
    const fields = {
      name: "Conteúdo",
      segment_name: "Segmento",
      discipline_name: "Disciplina",
      count: "Acessos",
      time: "Tempo médio"
    };

    return (
      <>
        {this.state.iframe && (
          <InterfaceModal
            show={this.state.iframe}
            title={this.state.contentName}
            onClose={() => this.setState({ iframe: false })}
            aula={this.state.contentId}
          />
        )}
        <CModal
          show={this.props.show}
          onClose={() => this.props.onClose()}
          centered
          size="xl"
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle className="m-0">
              Detalhamento de conteúdos acessados
            </CModalTitle>
          </CModalHeader>
          <CModalBody style={{ maxHeight: "80vh", overflowY: "auto" }}>
            {this.state.loading ? (
              <div className="d-flex align-items-center justify-content-center p-5">
                <CSpinner color="secondary" size="sm" />
              </div>
            ) : (
              <>
                <div className="d-flex w-100 justify-content-end mb-3">
                  <strong>Total de acessos:</strong>&nbsp;
                  {this.state.data.reduce((acc, val) => acc + val.count, 0)}
                </div>
                <CDataTable
                  items={this.state.data}
                  fields={Object.keys(fields)}
                  columnHeaderSlot={fields}
                  scopedSlots={{
                    name: item => (
                      <td>
                        <CLink
                          href="#"
                          onClick={e => this.openInterface(e, item)}
                        >
                          {item.name}
                        </CLink>
                      </td>
                    ),
                    time: item => (
                      <td>
                        {new Date(Number(item.time * 1000))
                          .toISOString()
                          .substr(11, 8)}
                      </td>
                    )
                  }}
                />
              </>
            )}
          </CModalBody>
        </CModal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  note: state.note
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalContentDetails);
